export const VERSION = '0.22.0'; // x-release-please-version
//# sourceMappingURL=version.mjs.map